import axios, { AxiosInstance, AxiosResponse } from 'axios';

export interface DeveloperCreateUserRequest {
  name: string;
  email: string;
  password: string;
  role: 'DEVELOPER' | 'ADMIN' | 'MANAGER' | 'OPERATOR' | 'VIEWER';
  cnpj: string;
}

export interface User {
  id: string;
  name: string;
  email: string;
  role: 'DEVELOPER' | 'ADMIN' | 'MANAGER' | 'OPERATOR' | 'VIEWER';
  cnpj: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

class DeveloperService {
  private client: AxiosInstance;

  constructor() {
    this.client = axios.create({
      baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3000/api',
      timeout: 10000,
    });

    // Interceptor para adicionar token JWT
    this.client.interceptors.request.use(
      (config) => {
        const token = localStorage.getItem('accessToken');
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );
  }

  async createUserForAnyCompany(userData: DeveloperCreateUserRequest): Promise<User> {
    try {
      const response: AxiosResponse<User> = await this.client.post('/developer/users', userData);
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.error || 'Erro ao criar usuário');
    }
  }

  async listUsersFromAnyCompany(cnpj?: string): Promise<User[]> {
    try {
      const params = cnpj ? { cnpj } : {};
      const response: AxiosResponse<User[]> = await this.client.get('/developer/users', { params });
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.error || 'Erro ao listar usuários');
    }
  }

  async updateUserFromAnyCompany(userId: string, userData: Partial<User>): Promise<User> {
    try {
      const response: AxiosResponse<User> = await this.client.put(`/developer/users/${userId}`, userData);
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.error || 'Erro ao atualizar usuário');
    }
  }
}

export const developerService = new DeveloperService();
export default developerService;
